import React from "react";
import { Box, Grid, Skeleton } from "@mui/material";

const WheelGridSkeletonLoader = ({ count = 8 , sx={} }) => {
  return (
    <Grid spacing={2} sx={{ ...sx }} container>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Box>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="200px"
              sx={{ borderRadius: "8px", marginBottom: "8px" }}
            />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="40%" />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default WheelGridSkeletonLoader;
